import { func, object, arrayOf, string } from 'prop-types';
import { path } from 'ramda';
import React from 'react';

import ActionButton from 'components/ActionButton';
import ContentColumns from '../components/ContentColumns';

import View1 from './Views/View1';
import View2 from './Views/View2';
import View3 from './Views/View3';
import View4 from './Views/View4';
import View5 from './Views/View5';
import View6 from './Views/View6';
import { getAllCommitsData } from 'lib/documentHandling';

class Rehabilitation4 extends React.Component {
  state = {
    view: 1,
  };

  componentDidMount() {
    const finished = path(['formValues', 'rehab4', 'finished'], this.context);
    // If this session is finished, navigate to last view
    if (finished) this.setState({ view: 6 });
  }

  advanceView = () => {
    const { setFinished, formValues } = this.context;
    const followedPlan = path(['rehab4', 'followedPlan'], formValues);

    if (this.state.view === 3 && followedPlan) {
      this.setState({ view: 5 }); // Skip view 4 if followedPlan
    } else if (this.state.view === 5) {
      setFinished();
      this.setState({ view: this.state.view + 1 });
    } else {
      this.setState({ view: this.state.view + 1 });
    }
  };

  backView = () => {
    const { formValues } = this.context;
    const followedPlan = path(['rehab4', 'followedPlan'], formValues);
    if (this.state.view === 5 && followedPlan) {
      this.setState({ view: this.state.view - 2 });
    } else this.setState({ view: this.state.view - 1 });
  };

  render() {
    const thisRehabDoc = this.props.documents.find(d => d.documentId === this.context.editingDocumentId);
    const neurologistsComments = path(
      ['rehab3', 'neurologistsComments'],
      thisRehabDoc ? getAllCommitsData(thisRehabDoc, true) : {},
    );
    const { view } = this.state;
    return (
      <div>
        {view === 1 ? (
          <View1 advanceView={this.advanceView} neurologistsComments={neurologistsComments} />
        ) : view === 2 ? (
          <View2 />
        ) : view === 3 ? (
          <View3 neurologistsComments={neurologistsComments} />
        ) : view === 4 ? (
          <View4 />
        ) : view === 5 ? (
          <View5 />
        ) : view === 6 ? (
          <View6 />
        ) : null}
        <ContentColumns
          firstColumn={
            view !== 1 && (
              <div style={{ display: 'flex', marginTop: '2rem' }}>
                <div style={{ flex: 1 }}>
                  {view > 1 ? (
                    <ActionButton
                      localeId={'onlineRehabilitation.back'}
                      onClick={this.backView}
                      style={{ width: '15rem' }}
                      secondary
                    />
                  ) : null}
                </div>
                {view !== 6 && (
                  <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                    <ActionButton
                      localeId={view === 8 ? 'onlineRehabilitation.send' : 'onlineRehabilitation.advance'}
                      onClick={this.advanceView}
                      style={{ width: '15rem' }}
                      filledSecondary
                    />
                  </div>
                )}
              </div>
            )
          }
        />
      </div>
    );
  }
}

Rehabilitation4.contextTypes = { setFinished: func, formValues: object, editingDocumentId: string };
Rehabilitation4.propTypes = { documents: arrayOf(object) };

export default Rehabilitation4;
